// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/GeistMono-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/GeistMono-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the page is scrollable */
.container {
  position: relative;
}

.content {
  padding: 20px;
  background-color: #f4f4f4;
}

.spacer {
  height: 120vh; /* Creates scrollable space */
}

/* Menu styles */
.menu {
  width: 50%;
  background-color: rgba(55,55,55,0.3);
  border: 2px solid rgba(5,5,5,0.4);
  height: 50px;
  border-radius: 25px;
  backdropFilter: blur(5px);
  color: white;
  text-align: center;
  transition: all 0.3s ease-in-out;
  position: relative; /* Default position */
  vertical-align: middle;
}

@font-face {
    font-family: 'GeistMono';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
.imagecolumn {
  padding: 0px;
  vertical-align: middle;
}

.menu a {
  color: white;
  text-decoration: none;
  margin: 0 15px;
  font-weight: bold;
}

.menu.sticky {
  position: fixed;
  bottom: 10px;
  width: 50%;
  z-index: 50;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/components/stickymenu.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa,EAAE,6BAA6B;AAC9C;;AAEA,gBAAgB;AAChB;EACE,UAAU;EACV,oCAAoC;EACpC,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB,EAAE,qBAAqB;EACzC,sBAAsB;AACxB;;AAEA;IACI,wBAAwB;IACxB;mEACoE;IACpE,mBAAmB;IACnB,kBAAkB;AACtB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB","sourcesContent":["/* Ensure the page is scrollable */\n.container {\n  position: relative;\n}\n\n.content {\n  padding: 20px;\n  background-color: #f4f4f4;\n}\n\n.spacer {\n  height: 120vh; /* Creates scrollable space */\n}\n\n/* Menu styles */\n.menu {\n  width: 50%;\n  background-color: rgba(55,55,55,0.3);\n  border: 2px solid rgba(5,5,5,0.4);\n  height: 50px;\n  border-radius: 25px;\n  backdropFilter: blur(5px);\n  color: white;\n  text-align: center;\n  transition: all 0.3s ease-in-out;\n  position: relative; /* Default position */\n  vertical-align: middle;\n}\n\n@font-face {\n    font-family: 'GeistMono';\n    src: url('../assets/fonts/GeistMono-Regular.woff2') format('woff2'),\n         url('../assets/fonts/GeistMono-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n.imagecolumn {\n  padding: 0px;\n  vertical-align: middle;\n}\n\n.menu a {\n  color: white;\n  text-decoration: none;\n  margin: 0 15px;\n  font-weight: bold;\n}\n\n.menu.sticky {\n  position: fixed;\n  bottom: 10px;\n  width: 50%;\n  z-index: 50;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
